module.exports = __webpack_public_path__ + "img/close.0ae044c1.svg";